import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import classes from './group.module.scss';
import { apiHolder as api, apis } from 'api';
import MultiSelect from '../../../components/multiSelect/multiSelect';
import { getIn18Text } from 'api';
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const CreateGroupId = -999;
const Group = ({ originTagIds, manageGroup, sendSelectedIds, manageVisible }) => {
    const [tagList, setTagList] = useState([]);
    const [selectedTagIds, setSelectedTagIds] = useState([]);
    const [errMsg, setErrMsg] = useState('');
    const addGroup = (e) => {
        e.preventDefault();
        if (tagList.length > 0 && tagList[tagList.length - 1].tagId === CreateGroupId) {
            return;
        }
        setTagList([
            ...tagList,
            {
                tagId: CreateGroupId,
                tagName: getIn18Text('XINJIANDEFENZUMINGCHENG'),
            },
        ]);
    };
    const getTemplateTagList = async () => {
        var _a;
        trackApi.track('pc_markting_edm_template_group_click');
        resetErr();
        const res = await templateApi.getTemplateTagList({ templateType: 'PERSONAL' });
        if (res.success) {
            setTagList(((_a = res.data) === null || _a === void 0 ? void 0 : _a.tagList) || []);
            return;
        }
        setTagList([]);
    };
    const onCreateTags = async (tagName) => {
        const res = await templateApi.saveOrUpdateTemplateTag({ tagId: undefined, tagName: tagName || '', templateCategory: 'LX-WAIMAO' });
        if (res.success) {
            setTagList(tagList.map(item => {
                var _a, _b;
                if (item.tagId === CreateGroupId) {
                    return {
                        tagId: (_a = res.data) === null || _a === void 0 ? void 0 : _a.tagId,
                        tagName: (_b = res.data) === null || _b === void 0 ? void 0 : _b.tagName,
                    };
                }
                return item;
            }));
            resetErr();
            trackApi.track('pc_markting_edm_template_newgroup_operation', {
                operation: 'newobject',
            });
            return;
        }
        setErrMsg(res.message || '');
    };
    const onCancel = () => {
        const list = tagList.filter(item => {
            return item.tagId !== CreateGroupId;
        });
        setTagList(list);
        resetErr();
    };
    const resetErr = () => {
        setErrMsg('');
    };
    const onCheckedChange = (selection) => {
        if (selection.length > 10) {
            message.error({
                content: getIn18Text('ZUIDUOXUANZE10GEFENZU\uFF01'),
            });
            return;
        }
        setSelectedTagIds(selection);
        sendSelectedIds(selection);
    };
    const groupNameRender = () => {
        var _a;
        if (selectedTagIds.length === 0) {
            return getIn18Text('XUANZEFENZU');
        }
        const showName = ((_a = tagList.find(item => {
            return item.tagId === selectedTagIds[0];
        })) === null || _a === void 0 ? void 0 : _a.tagName) || getIn18Text('XUANZEFENZU');
        if (selectedTagIds.length === 1) {
            return React.createElement("span", { className: classes.groupName }, showName);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: classes.groupName }, showName),
            " ",
            React.createElement("span", { className: classes.num },
                "+",
                selectedTagIds.length - 1)));
    };
    useEffect(() => {
        setSelectedTagIds(originTagIds);
        getTemplateTagList();
    }, [originTagIds]);
    return (React.createElement(MultiSelect, { dataList: tagList.map(item => (Object.assign(Object.assign({}, item), { id: item.tagId, name: item.tagName }))), selectedIds: selectedTagIds, onCheckedChange: onCheckedChange, getSelectContent: getTemplateTagList, groupNameRender: groupNameRender, createItems: addGroup, manageItems: manageGroup, addCancel: onCancel, addItems: onCreateTags, errorMessage: errMsg, hidePopover: manageVisible, createGroupId: CreateGroupId }));
};
export default Group;
